module.exports = __webpack_public_path__ + "static/404_cloud_white.e5ccb462.png";